// client/src/components/AuthLayout.js
// Shared split-screen frame for the sign in and create account pages.
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import FlightIcon from '@mui/icons-material/Flight';
import { DARK_SECTION_COLOR } from './Banner';
import { useStore } from '../context/StoreContext';

const BENEFITS = ['Track your orders and deliveries', 'Save products to your wishlist', 'Check out faster with saved addresses'];

const AuthLayout = ({ eyebrow, title, children, footer }) => {
  const { store } = useStore();

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, minHeight: { md: 'calc(100vh - 140px)' } }}>
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' }, flexDirection: 'column', justifyContent: 'center',
          position: 'relative', overflow: 'hidden', p: { md: 6, lg: 10 }, color: '#fff', bgcolor: DARK_SECTION_COLOR,
          backgroundImage: (theme) => `radial-gradient(700px 480px at 80% 15%, ${alpha(theme.palette.primary.main, 0.7)}, transparent 70%)`,
        }}
      >
        <FlightIcon aria-hidden sx={{ position: 'absolute', top: 48, right: 56, fontSize: 96, transform: 'rotate(45deg)', opacity: 0.9 }} />
        <Typography sx={{ fontSize: { md: '2.5rem', lg: '3.25rem' }, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.05, mb: 3, maxWidth: 480 }}>
          Everything for your next build, in one place.
        </Typography>
        <Stack spacing={1.5}>
          {BENEFITS.map((benefit) => (
            <Stack key={benefit} direction="row" spacing={1.25} alignItems="center">
              <CheckIcon fontSize="small" />
              <Typography sx={{ color: 'rgba(255,255,255,0.85)' }}>{benefit}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>

      <Box sx={{ display: 'grid', placeItems: 'center', px: 3, py: { xs: 6, md: 8 } }}>
        <Box sx={{ width: '100%', maxWidth: 420 }}>
          <Typography variant="overline" color="primary" sx={{ display: 'block' }}>{eyebrow}</Typography>
          <Typography variant="h3" sx={{ fontSize: '2.1rem', lineHeight: 1.15, mb: 3.5 }}>
            {title || store.name}
          </Typography>
          {children}
          <Typography variant="body2" textAlign="center" sx={{ mt: 3, color: 'text.secondary' }}>{footer}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
